// Sensory subsection form field enum
export enum SensoryFormField {
  SENSORY_STATUS_EYES = 'medical-background/sensory/sensory-status-eyes',
  SENSORY_STATUS_EARS = 'medical-background/sensory/sensory-status-ears',
  SENSORY_STATUS_NOSE = 'medical-background/sensory/sensory-status-nose',
  SENSORY_STATUS_TOUCH = 'medical-background/sensory/sensory-status-touch',
  SENSORY_STATUS_TASTE = 'medical-background/sensory/sensory-status-taste',
  SENSORY_SYSTEM_SUMMARY = 'medical-background/sensory/system-summary'
}
